import { render, staticRenderFns } from "./summaryAssets.vue?vue&type=template&id=5e3c131c&scoped=true"
import script from "./summaryAssets.vue?vue&type=script&lang=js"
export * from "./summaryAssets.vue?vue&type=script&lang=js"
import style0 from "./summaryAssets.vue?vue&type=style&index=0&id=5e3c131c&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3c131c",
  null
  
)

export default component.exports